export enum GenericError {
	NOT_ENOUGH_AMMO = 'Not enough Ammo',
	ETHERSCAN_TRANSACTION_FAILED = 'Transaction failed, please check Etherscan for details',
	WALLET_LIMIT = 'You already own enough',
	NOT_AN_OWNER = 'You must be a Skvllpvnkz owner',
	ALLOWANCE_LIMIT_EXCEEDED = 'You need to increase the Ammo spending limit first.',
	EXISTING_TX_IN_PROGRESS = 'There is an existing transaction already pending.',
}
